import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CTASection from './components/CTASection';
import HomePortfolioSection from './components/HomePortfolioSection';
import ServicesShowcaseSection from '../portfolio/components/ServicesShowcaseSection';
import ToolsSection from '../../components/feature/ToolsSection';
import ValuePropositionSection from './components/ValuePropositionSection';
import HeroSectionVideo from './components/HeroSectionVideo';

export default function Home() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSectionVideo />
        <ServicesShowcaseSection />
        <HomePortfolioSection />
        <ToolsSection />
        <ValuePropositionSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
